









































import Vue from 'vue';
import { EAnchor } from '@/common/enums/anchor.enum';

interface ISingleContactInfo {
  EAnchor: typeof EAnchor;
  isEmpty: boolean;
}

export default Vue.extend({
  name: `SingleContactInfo`,
  data(): ISingleContactInfo {
    return {
      EAnchor,
      isEmpty: true,
    };
  },
  props: {
    email: {
      default: ``,
      type: String,
    },
    iconLink: {
      default: ``,
      type: String,
    },
    mobileNumber: {
      default: ``,
      type: String,
    },
    showPartnerLocationLink: {
      default: false,
      type: Boolean,
    },
    telephoneNumber: {
      default: ``,
      type: String,
    },
  },
  mounted(): void {
    if(!!this.email
      || !!this.iconLink
      || !!this.mobileNumber
      || !!this.telephoneNumber) {
      this.isEmpty = false;
    }
  },
});
